// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"7294e6b2","730":"328c25aa","810":"44823dc0"}[chunkId] + ".chunk.css";
};